import Card from '@mui/material/Card';
import InfoIcon from '@mui/icons-material/Info';
import { useTheme } from '@mui/material/styles';

interface props{
  amountOfPoint:any;
}

function ConfirmCard({amountOfPoint}:props) {
  const theme = useTheme();

  return (
    <div className=' w-80 flex justify-center mt-4'>
      <Card
        className="p-4 shadow-lg m-0 mx-4 w-screen"
        sx={{
          borderRadius: "10px",
          color: "#1E88E5"
        }}
      >
        <div className="flex items-center">
          <InfoIcon className="mr-2" sx={{ color: '#001a70' }}/>
          <span className='text-customBlue'>You have {amountOfPoint} points</span>
        </div>
      </Card>
    </div>
  );
}

export default ConfirmCard;
